import Form from "react-bootstrap/Form";

const CommandeStatusDropdown = ({ selectedStatus, onStatusChange }) => {
        const statusOptions = [
           { value: "", label: "Tous les statuts" },
           { value: 4, label: "En cours de validation" },
            { value: 3, label: "En préparation" },
            { value: 1, label: "En cours de livraison" },
            { value: 2, label: "Livré" },
            { value: 6, label: "Annulée" }
          ];



        return (
 <Form.Select
      value={selectedStatus}
      onChange={(e) => onStatusChange(e.target.value)}
      style={{ width: "auto" }} // facultatif, pour ne pas prendre toute la largeur
    >
      {statusOptions.map((status) => (
        <option key={status.value} value={status.value}>
          {status.label}
        </option>
      ))}
    </Form.Select>
  );
};
export default CommandeStatusDropdown;
